window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = $.extend({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = theme.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = theme.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = theme.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = theme.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = theme.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = theme.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = theme.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

theme.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/*---------------------------------------------------------------------------------------------------------------*/
theme.InstagramSection = (function(){
  function Instagram(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');  
   
    this.selectors = {
       instagramData: '#cgt_instagram_data_' + sectionId,
    }
   
   this._initInstagram();
   
  }
  
  Instagram.prototype = $.extend({}, Instagram.prototype, {
     _initInstagram: function(){
        var cgtInstagramAccessToken = $(this.selectors.instagramData).attr('data-token');
        var maxImages = $(this.selectors.instagramData).attr('data-count');
       
       
        var $collection = $('.instagram-collection');
        var $shotContainer = $collection.find('.instagram-container');
        var $profileLink = $collection.find('header a.button');

        //Instagram integration


        $.ajax({
          url: "https://api.instagram.com/v1/users/self/media/recent/?access_token="+cgtInstagramAccessToken+"&count=" + maxImages,
          dataType: "jsonp",
          timeout: 5000,
          success: function(data) {
            // Check to ensure valid data
            //console.log(data);
            if(data.data){
              if (data.data.length < maxImages) {
                maxImages = data.data.length;
              }
              for (var i = 0; i < maxImages; i++) {
                var image = data.data[i].images.low_resolution.url;
                var thumbnail = data.data[i].images.thumbnail.url;
                var link = data.data[i].link;
                var likes = data.data[i].likes.count;
                var comments = data.data[i].comments.count;
                var largerThumbnail = data.data[i].images.standard_resolution.url;
                
                var caption = '';
                if(data.data[i].caption){
                  caption = data.data[i].caption.text;
                  caption = caption.split(',').join(', ');
                }


                var $shot = $collection.find('.box.photo').first();
                if(i > 0){
                  $shot = $shot.clone();
                  $shot.appendTo($shotContainer);
                }

                var $shotImageContainer = $shot.find('figure');
                var $shotLinks = $shot.find('figure > a, li > a');
                var $shotCaption = $shot.find('figcaption > .cgt-hashtags');
                var $shotLikes = $shot.find('a.likes span.label');
                var $shotComments = $shot.find('a.comments span.label');

                // Add image
               

                // Set shot data
                $shotLinks.attr('href', link);
                $shotCaption.html(caption);
                $shotLikes.text(likes);
                $shotComments.text(comments);

                $shot.removeClass('shot-0');
                $shot.addClass('shot-' + i);
                $('.instagram-collection  .shot-' + i).css('background', 'url('+largerThumbnail+') center center/cover no-repeat' );
              }
              //console.log(data);
              var instagramFeed = 'http://www.instagram.com/' + data.data[0].user.username;
              $profileLink.attr('href', instagramFeed);
              $profileLink.attr('target', '_blank');

              $collection.show();
            }

          }
        });  
       
     }
  });
  
  return Instagram;
})();

/*---------------------------------------------------------------------------------------------------------------*/
theme.Product = (function() {
 function Product(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');  
   
   this.settings = {
      autoplay: false,
      arrows: true,
      dots: false,
      mobile: false,
      infinite: true,
  	  slidesToShow: 4,
      slidesToScroll: 1
   };
   
   this.selectors = {
   	  productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
   }
   
   this._initThumbnailSlider();
   
  }
  
  Product.prototype = $.extend({}, Product.prototype, {
     _initThumbnailSlider: function(){
     	$(this.selectors.productThumbs).slick(this.settings);
     }
  });
  
  return Product;
})();


/*---------------------------------------------------------------------------------------------------------------*/
theme.Slideshow = (function() {
  this.$slideshow = null;
  var classes = {
    wrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    currentSlide: 'slick-current',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused'
  };

  function slideshow(el) {
    this.$slideshow = $(el);
    this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
    this.$pause = this.$wrapper.find('.' + classes.pauseButton);

    this.settings = {
      accessibility: true,
      arrows: true,
      dots: true,
      draggable: true,
      touchThreshold: 20,
      autoplay: this.$slideshow.data('autoplay'),
      autoplaySpeed: this.$slideshow.data('speed')
    };

    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11y.bind(this));
    this.$slideshow.slick(this.settings);

    this.$pause.on('click', this.togglePause.bind(this));
  }

  function slideshowA11y(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    var $wrapper = this.$wrapper;
    var autoplay = this.settings.autoplay;

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    $wrapper.on('focusin', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.attr('aria-live', 'polite');

      if (autoplay) {
        $slider.slick('slickPause');
      }
    });

    // Resume autoplay
    $wrapper.on('focusout', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.removeAttr('aria-live');

      if (autoplay) {
        $slider.slick('slickPlay');
      }
    });

    // Add arrow key support when focused
    if (obj.$dots) {
      obj.$dots.on('keydown', function(evt) {
        if (evt.which === 37) {
          $slider.slick('slickPrev');
        }

        if (evt.which === 39) {
          $slider.slick('slickNext');
        }

        // Update focus on newly selected tab
        if ((evt.which === 37) || (evt.which === 39)) {
          obj.$dots.find('.slick-active button').focus();
        }
      });
    }
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $slider = slick.$slider;
    var $currentSlide = $slider.find('.' + classes.currentSlide);
    var $nextSlide = $slider.find('.slideshow__slide[data-slick-index="' + nextSlide + '"]');
  }

  slideshow.prototype.togglePause = function() {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused);
      $(slideshowSelector).slick('slickPlay');
    } else {
      this.$pause.addClass(classes.isPaused);
      $(slideshowSelector).slick('slickPause');
    }
  };

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();


/*---------------------------------------------------------------------------------------------------------------*/
theme.slideshows = {};

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#Slideshow-' + sectionId;

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = $.extend({}, theme.SlideshowSection.prototype, {
  onUnload: function() {
    delete theme.slideshows[this.slideshow];
  },

  onBlockSelect: function(evt) {
    var $slideshow = $(this.slideshow);

    // Ignore the cloned version
    var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
  },

  onBlockDeselect: function() {
    // Resume autoplay
    $(this.slideshow).slick('slickPlay');
  }
});

/*---------------------------------------------------------------------------------------------------------------*/
theme.CarouselSection = (function() {
 function CarouselSection(container) {
   
   var $container = this.$container = $(container);
   var sectionId = $container.attr('data-section-id');  
   
   this.selectors = {
   	  selector: '.owl-carousel-' + sectionId,
   }
   
   this._initCarouselSlider( sectionId );
   
  }
  
  CarouselSection.prototype = $.extend({}, CarouselSection.prototype, {
     _initCarouselSlider: function( sectionId ){
       	$( this.selectors.selector ).owlCarousel({
          loop:true,
          nav:true,
          autoplay: true,
          autoplayTimeout: 3000,
          autoplayHoverPause: true,
          margin: 30,
          navContainer: '#cauroselNav_'+ sectionId,
          navigation:true,
          lazyLoad: true,
          navText: [
             "<img src='//cdn.shopify.com/s/files/1/0003/8721/9521/t/4/assets/prev.png?v=35902743860889832661520036103'/>",
             "<img src='//cdn.shopify.com/s/files/1/0003/8721/9521/t/4/assets/next.png?v=110984758794851773731520036089'/>"
          ],
          responsive:{
              0:{
               items: 1
              },
              420:{
                  items:2
              },
              768:{
                  items:3
              },
              1000:{
                  items:4
              }
          }
      })
     }
  });
  return CarouselSection;
})();


/*---------------------------------------------------------------------------------------------------------------*/
theme.FeaturedSliderSection = (function() {
 function FeaturedSliderSection(container) {
   
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');  
   
   this.settings = {
      nav: true,
      dots: false,
      autoplay: true,
      loop: true,
  	  items: 5,
   };
   
   this.selectors = {
   	  selector: '.featured-carousel-' + sectionId,
   }
   
   this._initCarouselSlider( sectionId );
   
  }
  
  FeaturedSliderSection.prototype = $.extend({}, FeaturedSliderSection.prototype, {
     _initCarouselSlider: function( sectionId ){
       	$( this.selectors.selector ).owlCarousel({
          loop:true,
          nav:true,
          autoplay: true,
          autoplayTimeout: 3000,
          autoplayHoverPause: true,
          navigation:true,
          items: 1,
          navText: [
             "<i class='fa fa-angle-left'></i>",
             "<i class='fa fa-angle-right'></i>"
          ]
      })
     }
  });
  return FeaturedSliderSection;
})();


/*---------------------------------------------------------------------------------------------------------------*/
theme.StatementSection = (function() {
 function StatementSection(container) {
   
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');  
   
   this.selectors = {
   	  selector: '.statement-carousel-' + sectionId,
   }
   
   $(this.selectors.selector).addClass('owl-carousel');
   this._initCarouselSlider( sectionId );
   
  }
  
  StatementSection.prototype = $.extend({}, StatementSection.prototype, {
     _initCarouselSlider: function( sectionId ){
       	$( this.selectors.selector ).owlCarousel({
          nav: true,
          dots: false,
          autoplay: false,
          loop: true,
          items: 1,
          nav:true,
          autoplay: true,
          autoplayTimeout: 3000,
          autoplayHoverPause: true,
          margin: 30,
          navigation:true,
          navText: [
             "<i class='fa fa-angle-left'></i>",
             "<i class='fa fa-angle-right'></i>"
          ],
          responsive:{
              0:{
               items: 1
              },
              768:{
                  items:1
              },
              1170:{
                  items:1
              }
          }
      })
     }
  });
  return StatementSection;
})();

/*------------------------------------------------------------------------------------------------------*/
window.cgthemes = window.cgthemes || {};

cgthemes.search_toggle = function() {
  var $searchIcon = $( '.cgt-ajax-search .cgt-icon' ),
      $searchToggle = $('.site-header__search');
      $searchIcon.click(function(){
        $searchToggle.slideToggle('slow');
      });
}


cgthemes.menu_toggle = function() {
  var $toggleNav = $('.cgt-toggle');
      $toggleNav.click(function(){
        $(this).next('.cgt-submenu-wrapper').slideToggle('slow');
        $(this).toggleClass('icon_plus icon_minus-06' );
      });
}

cgthemes.contact_toggle = function() {
  $('.cgt-toggle-contact , .cgt-icon.icon_close').click(function(){
    $('.cgt-quick-contact').slideToggle('slow');
  });
}

cgthemes.slider_height = function(){
var sHeight = $( window ).height();
  var sWidth = $( window ).width();
  if(sWidth > 768 ){
    $('.slideshow , .slideshow__image').height(sHeight-100)
  }
}

cgthemes.attachClickEvent = function(){
  var pInfScrLoading = false;
  var pInfScrDelay = 250;
  function pInfScrExecute( cgt_load_id ) {
    var cgt_more = '.more_'+ cgt_load_id;
    var cgt_more_a = '.more_'+ cgt_load_id+' a';
    pInfScrNode = $(cgt_more).last();	
    pInfScrURL = $(cgt_more_a).last().attr("href");
    if(pInfScrNode.length > 0 && pInfScrNode.css('display') != 'none') {
      $.ajax({
        type: 'GET',
        url: pInfScrURL,
        beforeSend: function() {
          pInfScrLoading = true;
          pInfScrNode.clone().empty().insertAfter(pInfScrNode).append('<img src=\"http://cdn.shopify.com/s/files/1/0068/2162/assets/loading.gif?105791\" />');
          pInfScrNode.hide();
        },
        success: function(data) {
          // remove loading feedback
          pInfScrNode.next().remove();
          pInfScrNode.remove();
          var cgt_load = '.collection-matrix_'+cgt_load_id;
          var filteredData = $(data).find(cgt_load);
          filteredData.insertBefore( $('#product_more_'+cgt_load_id) );					
          pInfScrLoading = false;
          attachClickEvent();
        },
        dataType: "html"
      });

    }
  }
  
  $('.more').click(function(event){
    var cgt_load_id = $(this).attr('data');
    pInfScrExecute( cgt_load_id );
    event.stopPropagation();
    return false;
  });
}


cgthemes.productTabs = function(){
  $('.cgtTabs .tabs').click(function(){
    $('.section-details').removeClass('active');
    $('.tabs').removeClass('active');
    var swid = $(this).attr('id');
    var id = 'section_'+swid;
    $('.section-details').hide();
    $(this).addClass('active');
    $('#'+id).show();
  });
}

cgthemes.productPhoto = function(){
  $("#ProductPhoto img").load(function(){
    var height = $(this).height();
    $('.vc_container').height(height-15);
  });
}

// Ajax add to cart
cgthemes.add_to_cart_ajax = function( id, quantity, modal ) {
    $( 'body' ).on( 'click', '#addToCart', function( e ) {
        e.preventDefault();
        var icon       = $( this ).children( 'i' ),
            product_id = $( this ).siblings( '.product-single__variants' ).val(),
			quantity   = parseInt( $( '.quantity__selector' ).val() );

        if ( product_id == null ) {
            $( 'body' ).addClass( 'mask' ).append( '<div class="notice notice--error is-fixed is-flex"><div class="notice__icon is-flex middle-xs"><i class="fa fa-shopping-basket"></i></div><div class="notice__content"><p>translation missing: en.product.notice_error</p>translation missing: en.product.notice_error_btn_html</div></div>' );
            $( 'body' ).on( 'click', '.btn', function( e ) {
                e.preventDefault();
                $( 'body' ).removeClass( 'mask' );
                $( '.notice' ).remove();
            });
			return;
		}

        // Make sure quantity is number
        quantity = ( isNaN( quantity ) ) ? 1 : quantity;

        // Add loading icon
        icon.removeClass( 'fa-shopping-basket' ).addClass( 'fa-spinner fa-pulse' );

        // Render status when add to cart is error
        Shopify.onError = function(XMLHttpRequest, textStatus) {
            var data = eval('(' + XMLHttpRequest.responseText + ')');
            if ( !! data.message ) {
                icon.parent().addClass( 'disabled' );
                icon.removeClass( 'fa-spinner fa-pulse' ).addClass( 'fa-exclamation-triangle' );

                $( 'body' ).append( '<div class="notice error is-fixed is-flex"><div class="notice__icon is-flex middle-xs"><i class="fa fa-shopping-basket"></i></div><div class="notice__content">' + data.description + '</div><a class="notice__close is-absolute" href="#">×</a></div>' );
                setTimeout( function() {
                    $( '.notice' ).addClass( 'active' );
                }, 50);
            }
        };

        Shopify.addItem( product_id, quantity, function( data ) {
            Shopify.getCart( function( all_data ) {
                // Remove loading icon and add check icon for product added
                icon.removeClass( 'fa-spinner fa-pulse' ).addClass( 'fa-check' );

                // Revert to icon shopping basket after 4s
                setTimeout( function() {
                    icon.removeClass( 'fa-check' ).addClass( 'fa-shopping-basket' );
				}, 4000 );

                // Add cart notice
                $( 'body' ).append( '<div class="notice is-fixed is-flex"><div class="notice__icon is-flex middle-xs"><i class="fa fa-shopping-basket"></i></div><div class="notice__content"><p><strong>' + data.product_title + '</strong> translation missing: en.product.notice</p>translation missing: en.product.notice_btn_html</div><a class="notice__close is-absolute" href="#">×</a></div>' );
                setTimeout( function() {
                    $( '.notice' ).addClass( 'active' );
				}, 50);

                // Change product quantity in mini cart
				$( '.top__cart span' ).text( all_data.item_count );
            });
        });
    });
}

cgthemes.lightbox = function(){
  $('.lightbox').magnificPopup({
    type: 'image',
    gallery: {
      // options for gallery
      enabled: true
    }
  });
}


cgthemes.filter = function(){
  $('.collection-filter-btn , .collection-filter-tags , .collection-dropdown-btn').click(function(){
    $(this).next().toggleClass('active');
    if( $('.filter-content').hasClass('active') ){
    	$('.collection-grid-overlay').addClass('active-mode');
    }else{
    	$('.collection-grid-overlay').removeClass('active-mode');
    }
  });
}  

cgthemes.lazyload = function(){
	$(".lazyload").lazyload();
}

cgthemes.animation = function(){
   new WOW().init();
}

/*------------------------------------------------------------------------------------------------------*/
$(function() {
  var sections = new theme.Sections();

  sections.register('product', theme.Product);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('carousel-section', theme.CarouselSection);
  sections.register('statement-section', theme.StatementSection);
  sections.register('featured-section', theme.FeaturedSliderSection);
  sections.register('instagram-section', theme.InstagramSection);
  
  cgthemes.search_toggle();
  cgthemes.menu_toggle();
  cgthemes.contact_toggle();
  cgthemes.lightbox();
  cgthemes.productPhoto();
  cgthemes.productTabs();
  cgthemes.attachClickEvent();
  cgthemes.add_to_cart_ajax();
  cgthemes.slider_height();
  cgthemes.filter();
  cgthemes.animation();
  
});